export default "__VITE_ASSET__DKIH4RWY__"